// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  resultId: __t.u64().primaryKey().name("result_id"),
  actionId: __t.u64().name("action_id"),
  attacker: __t.identity(),
  attackerLife: __t.u32().name("attacker_life"),
  targetKind: __t.string().name("target_kind"),
  targetPlayer: __t.identity().name("target_player"),
  targetId: __t.u64().name("target_id"),
  targetLife: __t.u32().name("target_life"),
  outcome: __t.string(),
  dmg: __t.i32(),
  itemKey: __t.string().name("item_key"),
  contextKind: __t.string().name("context_kind"),
  contextId: __t.u64().name("context_id"),
  worldId: __t.u64().name("world_id"),
  at: __t.timestamp(),
});
